import type { TeamCelebration, TeamCelebrationKind } from "./teamCelebrations";

const TEAM_CELEBRATION_ARTWORK: Record<TeamCelebrationKind, string[]> = {
  anniversary: Array.from(
    { length: 6 },
    (_, index) => `/celebrations/anniversary-cat-v${index + 1}.png`
  ),
  birthday: Array.from(
    { length: 6 },
    (_, index) => `/celebrations/birthday-cat-v${index + 1}.png`
  ),
};

export function getTeamCelebrationArtwork(
  item: Pick<TeamCelebration, "kind" | "key" | "userId">
): { src: string; alt: string } {
  const year = Number(/^([0-9]{4})-/.exec(item.key)?.[1] ?? 0);
  let seed = 2166136261;
  for (const char of `${item.kind}:${item.userId}`) {
    seed ^= char.charCodeAt(0);
    seed = Math.imul(seed, 16777619);
  }
  const paths = TEAM_CELEBRATION_ARTWORK[item.kind];
  const index = ((seed >>> 0) + year) % paths.length;
  return {
    src: paths[index],
    alt:
      item.kind === "birthday"
        ? "Кот поздравляет с днём рождения"
        : "Кот поздравляет с годовщиной работы",
  };
}
